import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/itemTags'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  itemTag: {},
  itemTags: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  itemTag: state => state.itemTag,
  itemTags: state => state.itemTags
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_ITEM_TAG = 'REQUEST_GET_ITEM_TAG'
const RECEIVE_GET_ITEM_TAG = 'RECEIVE_GET_ITEM_TAG'

const REQUEST_CREATE_ITEM_TAG = 'REQUEST_CREATE_ITEM_TAG'
const RECEIVE_CREATE_ITEM_TAG = 'RECEIVE_CREATE_ITEM_TAG'

const REQUEST_UPDATE_ITEM_TAG = 'REQUEST_UPDATE_ITEM_TAG'
const RECEIVE_UPDATE_ITEM_TAG = 'RECEIVE_UPDATE_ITEM_TAG'

const REQUEST_DELETE_ITEM_TAG = 'REQUEST_DELETE_ITEM_TAG'
const RECEIVE_DELETE_ITEM_TAG = 'RECEIVE_DELETE_ITEM_TAG'

const UPDATE_ITEM_TAG_PROPERTY = 'UPDATE_ITEM_TAG_PROPERTY'

const REQUEST_GET_ITEM_TAGS = 'REQUEST_GET_ITEM_TAGS'
const RECEIVE_GET_ITEM_TAGS = 'RECEIVE_GET_ITEM_TAGS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getItemTags ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting itemTags', { root: true })
    commit(REQUEST_GET_ITEM_TAGS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveItemTags', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting itemTags', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting itemTags', { root: true })
        return Promise.reject(error)
      })
  },
  async getItemTag ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting itemTag', { root: true })
    commit(REQUEST_GET_ITEM_TAG, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveItemTag', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting itemTag', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting itemTag', { root: true })
        return Promise.reject(error)
      })
  },
  async createItemTag ({ commit, dispatch }, data) {
    dispatch('wait/start', 'creating itemTag', { root: true })
    commit(REQUEST_CREATE_ITEM_TAG, data)
    return axios.post(`${endpointConfig.url}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItemTag', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating itemTag', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating itemTag', { root: true })
        return Promise.reject(error)
      })
  },
  async updateItemTag ({ commit, dispatch }, [ id, data ]) {
    dispatch('wait/start', 'updating itemTag', { root: true })
    commit(REQUEST_UPDATE_ITEM_TAG, id)
    return axios.put(`${endpointConfig.url}/${id}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItemTag', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating itemTag', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating itemTag', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteItemTag ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting itemTag', { root: true })
    commit(REQUEST_DELETE_ITEM_TAG, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_ITEM_TAG, response.data)
        dispatch('wait/end', 'deleting itemTag', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting itemTag', { root: true })
        return Promise.reject(error)
      })
  },
  receiveItemTag ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEM_TAG`, extract(json))
    return json.data
  },
  receiveItemTags ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEM_TAGS`, extract(json))
    return json.data
  },
  updateItemTagProperty ({ commit, dispatch }, [ property, value ]) {
    commit(`UPDATE_ITEM_TAG_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_ITEM_TAG] (state, id) {
  },
  [RECEIVE_GET_ITEM_TAG] (state, json) {
    state.itemTag = json
  },
  [REQUEST_CREATE_ITEM_TAG] (state, json) {
  },
  [RECEIVE_CREATE_ITEM_TAG] (state, json) {
    state.itemTag = json
  },
  [REQUEST_UPDATE_ITEM_TAG] (state, id) {
  },
  [RECEIVE_UPDATE_ITEM_TAG] (state, json) {
    state.itemTag = json
  },
  [REQUEST_DELETE_ITEM_TAG] (state, id) {
  },
  [RECEIVE_DELETE_ITEM_TAG] (state, json) {
    state.itemTag = {}
  },
  [UPDATE_ITEM_TAG_PROPERTY] (state, [ property, value ]) {
    state.itemTag[property] = value
  },
  [REQUEST_GET_ITEM_TAGS] (state) {
  },
  [RECEIVE_GET_ITEM_TAGS] (state, json) {
    state.itemTags = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
